
/* Lotsa Goodies / collection discovery progressive enhancement */
(function(){
  'use strict';
  function init(){
  if(window.__lgdcReady)return;
  var host=document.querySelector('[data-lgdc-section]');
  if(!host)return;
  window.__lgdcReady=true;
  var sort=host.querySelector('#lgdc-sort');
  if(sort)sort.addEventListener('change',function(){if(sort.form){if(sort.form.requestSubmit)sort.form.requestSubmit();else sort.form.submit();}});
  var grid=host.querySelector('#lgdc-products');
  var next=host.querySelector('#lgdc-more');
  if(!grid||!next||!window.fetch||!window.DOMParser)return;
  var busy=false, observer;
  async function appendPage(){
    if(busy||!next||!next.href||next.hidden)return;
    busy=true;next.setAttribute('aria-busy','true');
    var oldText=next.innerHTML;next.textContent='Finding more goodies…';
    try{
      var response=await fetch(next.href,{credentials:'same-origin',headers:{'Accept':'text/html'}});
      if(!response.ok)throw new Error('Could not load the next page');
      var doc=new DOMParser().parseFromString(await response.text(),'text/html');
      var newGrid=doc.querySelector('#lgdc-products');
      if(!newGrid)throw new Error('Missing product grid');
      var cards=Array.from(newGrid.querySelectorAll('.lgdc-grid-item'));
      if(!cards.length)throw new Error('No more products found');
      cards.forEach(function(card){grid.appendChild(document.importNode(card,true));});
      var upcoming=doc.querySelector('#lgdc-more');
      var status=doc.querySelector('#lgdc-page-status');
      var ourStatus=host.querySelector('#lgdc-page-status');
      if(ourStatus&&status)ourStatus.textContent=status.textContent;
      if(upcoming&&upcoming.getAttribute('href')){
        next.href=upcoming.href;
        next.innerHTML=oldText;
      }else{
        next.hidden=true;
        if(ourStatus)ourStatus.textContent="You've reached the end of this collection! ♥";
      }
    }catch(err){
      next.innerHTML=oldText;
      if(observer)observer.disconnect();
    }finally{
      busy=false;next.removeAttribute('aria-busy');
    }
  }
  next.addEventListener('click',function(event){event.preventDefault();appendPage();});
  if('IntersectionObserver' in window){
    observer=new IntersectionObserver(function(items){if(items.some(function(item){return item.isIntersecting;}))appendPage();},{rootMargin:'220px 0px',threshold:0});
    observer.observe(next);
  }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
